<div  *ngIf="!hideHeader">
    <!-- Tab Mobile View Header -->
<!-- <div id="eq-loader">
        <div class="eq-loader-div">
            <div class="eq-loading dual-loader mx-auto mb-5"></div>
        </div>
    </div> -->
    <header class="tabMobileView header navbar fixed-top d-lg-none" *ngIf="logged !=undefined && !landing_page" style="position: inherit;"> 
        <ul class="navbar-nav flex-row ml-lg-auto w-100">
            <li class="nav-item dropdown user-profile-dropdown w-100 text-center " >
                <div class="nav-toggle d-inline-block float-left " *ngIf="comp=='WAM'">
                    <a href="/" class="ml-3" *ngIf="comp=='WAM'">
                        <h5 [style.color]="comp =='WAM' ? '#fff200 !important': 'white'" style="margin-top: -20px;" class="titleComp">
                        <!-- <img [src]="logoCompany?logoCompany:'assets/logo_wam.png'" *ngIf="comp=='WAM'"> -->
                        <img src="../assets/img/suivitim_img/logo_menu_mobile.png">
                        <!-- <span class="titleGroup" *ngIf="comp =='WAM'">WAMGROUP</span> -->
                    </h5></a>
                </div>
                <div class="nav-toggle d-inline-block float-left mt-3" *ngIf="comp!='WAM'">
                    <a href="/" >
                        <img src="../assets/img/suivitim_img/logo_menu_mobile.png">
                        <!-- <img [src]="logoCompany" style="width: 140px !important;max-height: 60px;" *ngIf="comp!='WAM'"> -->
                    </a>
                </div>
                <!-- <div class="navbar-brand text-center"  *ngIf="medium">
                    <h4 class="mb-0" style="font-weight: 600;color: white">Gestion des visites clients</h4>
                </div> -->
                <a href="profil" class="nav-link dropdown-toggle user d-inline-block float-right" aria-expanded="false">
                    <div class="media">
                        <img [src]="imagesource" class="img-fluid mr-2" alt="admin-profile"
                            [ngClass]="{'border-basic': myPack==='Basique' && role=='adm','border-custom':  myPack==='Sur mesure' && role=='adm','border-advanced':  myPack==='Advanced' && role=='adm','border-premium':  myPack==='Premium' && role=='adm'}">
                        <div class="media-body align-self-center" style="color:rgb(4, 35, 64) !important ;text-align: start;">
                            <h6 class="mb-1" style="text-align:s">{{fullnameconnected}}</h6>
                            <p class="mb-0" *ngIf="role!='asst'">{{roleconnected}}</p>
                            <p class="mb-0" *ngIf="role=='adm-MF'">{{roleconnected}}</p>
                            <p class="mb-0" *ngIf="role=='asst'" style="font-size: 7px !important;">{{roleconnected}}</p>
                            <p class="mb-0" style="font-size: 12px;color: #a8f1ff;" 
                                    *ngIf="connectedCompany!=null && connectedCompany != undefined && role!='adm-MF'">
                                    <b>{{connectedCompany}}</b></p>
                        </div>
                    </div>
                </a>
                <div class="dropdown-menu p-0 mt-5" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item d-flex mt-5" href="user_profile.html">
                        <i class="mr-3 flaticon-user-11"></i> <span class="align-self-center">Profile</span>
                    </a>
                    <a class="dropdown-item d-flex" href="apps_scheduler.html">
                        <i class="mr-3 flaticon-calendar"></i> <span class="align-self-center">My Schedule</span>
                    </a>
                    <a class="dropdown-item d-flex" href="apps_mailbox.html">
                        <i class="mr-3 flaticon-mail-22"></i> <span class="align-self-center">Inbox</span>
                    </a>
                    <a class="dropdown-item d-flex" href="user_lockscreen_1.html">
                        <i class="mr-3 flaticon-lock-1"></i> <span class="align-self-center">Lock Screen</span>
                    </a>
                    <a href="user_login_1.html" class="dropdown-item dropdown-item-btn">
                        <i class="mr-2 flaticon-power-off"></i> <span class="align-self-center">Logout</span>
                    </a>
                </div>
            </li>
        </ul>
    </header> 
<!-- Tab Mobile View Header -->
<!--  BEGIN NAVBAR  -->
    <header class="desktop-nav header navbar fixed-top" *ngIf="logged !=undefined && !landing_page"> 
        <div class="nav-logo mr-5 ml-4  d-lg-inline-block d-none" >
            <a href="/dashboard" *ngIf="role=='adm'">
                <h4 [style.color]="comp =='WAM' ? '#fff200 !important': 'white'" class="mb-2 mt-2">
                    <!-- <img src="../assets/logo_wam.png" *ngIf="comp=='WAM'" style="margin-top: -15px !important;"> -->
                    <img src="../assets/img/suivitim_img/logo_menu.png">
                    <!-- <span class="mt-2 titleGroup" *ngIf="comp =='WAM'">WAMGROUP</span> -->
                </h4>
            </a>
            <a href="/dash" *ngIf="role=='asst'">
                <h4 [style.color]="comp =='WAM' ? '#fff200 !important': 'white'" class="mb-2 mt-2">
                    <!-- <img src="../assets/logo_wam.png" *ngIf="comp=='WAM'" style="margin-top: -15px !important;"> -->
                    <img src="../assets/img/suivitim_img/logo_menu.png">
                    <!-- <span class="mt-2 titleGroup" *ngIf="comp =='WAM'">WAMGROUP</span> -->
                </h4>
            </a>
            <a href="/mydash" *ngIf="role=='cmrc'">
                <h4 [style.color]="comp =='WAM' ? '#fff200 !important': 'white'" class="mb-2 mt-2">
                    <!-- <img src="../assets/logo_wam.png" *ngIf="comp=='WAM'" style="margin-top: -15px !important;"> -->
                    <img src="../assets/img/suivitim_img/logo_menu.png">
                    <!-- <span class="mt-2 titleGroup" *ngIf="comp =='WAM'">WAMGROUP</span> -->
                </h4>
            </a>
            <a href="/dash-support" *ngIf="role=='support'">
                <h4 [style.color]="comp =='WAM' ? '#fff200 !important': 'white'" class="mb-2 mt-2">
                    <!-- <img src="../assets/logo_wam.png" *ngIf="comp=='WAM'" style="margin-top: -15px !important;"> -->
                    <img src="../assets/img/suivitim_img/logo_menu.png">
                    <!-- <span class="mt-2 titleGroup" *ngIf="comp =='WAM'">WAMGROUP</span> -->
                </h4>
            </a>
        </div>
        <ul class="navbar-nav flex-row mr-auto" *ngIf="role=='adm'" id="topAccordion">
            <li class="nav-item dropdown app-dropdown">
                <a href="javascript:void(0);" class="nav-link dropdown-toggle icon_menu_mobile" id="app-dropdown" 
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="flaticon-menu-line-2"></span>
                </a>
                <div class="dropdown-menu  position-absolute" aria-labelledby="app-dropdown">
                        <a class="dropdown-item d-flex" href="dashboard">
                            <i class="flaticon-computer-6 mr-3"></i><span>Tableau de bord</span>
                        </a>
                        <a class="dropdown-item d-flex" href="visites" routerLink="/visites">
                            <i class="mr-3 flaticon-car-1"></i><span>Visites</span>
                        </a>
                        <a class="dropdown-item d-flex" href="actions" routerLink="/actions">
                            <i class="mr-3 flaticon-menu-list"></i><span>Actions</span>
                        </a>
                        <a class="dropdown-item d-flex" href="customers/show;cs=all" routerLink="customers/show;cs=all">
                            <i class="mr-3 flaticon-building-1"></i><span>Clients</span>
                        </a>
                        <a class="dropdown-item d-flex" href="contacts">
                            <i class="mr-3 fa fa-address-book-o"></i><span>Contacts</span>
                        </a>
                        <a class="dropdown-item d-flex" routerLink="absence">
                            <i class="flaticon-calendar-1"></i><span>Absences</span>
                        </a>
                        <a *ngIf="hasRole('satisfaction')" class="dropdown-item d-flex" routerLink="surveys-list">
                            <i class="flaticon-multi-star-fill"></i><span> Enquêtes</span>
                        </a>
                        <a data-toggle="collapse" aria-expanded="false" class="dropdown-toggle dropdown-item d-flex" href="staticticss" >
                            <i class="mr-3 flaticon-stats"></i><span>Statistiques</span>
                            <!-- <div>
                                <i class="flaticon-down-arrow flaticon-down-arrow-menu"></i>
                            </div> -->
                        </a>
                        <div class="collapse submenu list-unstyled" id="staticticss" style="display: block;">                            
                            <div class="row">
                                <div class="col-lg-4 div-submenu-element-mobile">
                                    <ul class="list-unstyled submenu-element-mobile">
                                        <li><span style="font-size: xx-large;
                                            color: #70e3bc;">L</span>
                                            <a href="/statistics_customers" routerLink="statistics_customers" data-toggle="collapse" aria-expanded="true" class="dropdown-toggle p-0"> 
                                                <i class="flaticon-building-1"></i> Clients 
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-lg-4 div-submenu-element-mobile">
                                    <ul class="list-unstyled submenu-element-mobile">
                                        <li><span style="font-size: xx-large;
                                            color: #70e3bc;">L</span>
                                            <a href="statistics" routerLink="statistics" data-toggle="collapse" aria-expanded="true" class="dropdown-togglep-0"> 
                                                <i class="flaticon-user-group-1"></i> Commerciaux 
                                            </a>
                                            
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-lg-4 div-submenu-element-mobile">
                                    <ul class="list-unstyled submenu-element-mobile">
                                        <li><span style="font-size: xx-large;
                                            color: #70e3bc;">L</span>
                                            <a data-toggle="collapse" aria-expanded="true" class="dropdown-togglep-0" href="cover" routerLink="cover">
                                                <i class="flaticon-primary"></i> Couverture
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                </div>
            </li>
        </ul>
        <ul class="navbar-nav flex-row mr-auto" *ngIf="role=='adm-MF'">
            <li class="nav-item dropdown app-dropdown">
                <a href="javascript:void(0);" class="nav-link dropdown-toggle icon_menu_mobile" id="app-dropdown" 
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="flaticon-menu-line-2"></span>
                </a>
                <div class="dropdown-menu  position-absolute" aria-labelledby="app-dropdown">
                        <a class="dropdown-item d-flex" routerLink="/administration">
                            <i class="mr-3 flaticon-user-group-1"></i><span>Comptes Entreprises</span>
                        </a>
                </div>
            </li>
        </ul>
        <ul class="navbar-nav flex-row mr-auto" *ngIf="role=='cmrc'">
            <li class="nav-item dropdown app-dropdown">
                <a href="" class="nav-link dropdown-toggle icon_menu_mobile" id="app-dropdown" 
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="flaticon-menu-line-2"></span>
                </a>
                <div class="dropdown-menu  position-absolute" aria-labelledby="app-dropdown">
                    <a class="dropdown-item d-flex" href="mydash">
                    <i class="flaticon-computer-6 mr-3"></i><span>Tableau de bord</span>
                    </a>
                    <a class="dropdown-item d-flex" href="deplacement">
                        <i class="mr-3 flaticon-car-1"></i><span>Déplacements</span>
                    </a>
                    <a class="dropdown-item d-flex" href="actions">
                        <i class="mr-3 flaticon-menu-list"></i><span>Actions</span>
                    </a>
                    <a class="dropdown-item d-flex" href="my-customers/show;cs=all" routerLink="my-customers/show;cs=all">
                        <i class="mr-3 flaticon-building-1"></i><span>Clients</span>
                    </a>
                    <a class="dropdown-item d-flex" href="contacts">
                        <i class="mr-3 fa fa-address-book-o"></i><span>Contacts</span>
                    </a>
                    <a class="dropdown-item d-flex" routerLink="absence">
                        <i class="flaticon-calendar-1"></i><span>Absences</span>
                    </a>
                </div>
            </li>
        </ul>
        <ul class="navbar-nav flex-row mr-auto" *ngIf="role=='support'">
            <li class="nav-item dropdown app-dropdown">
                <a href="" class="nav-link dropdown-toggle icon_menu_mobile" id="app-dropdown" 
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="flaticon-menu-line-2"></span>
                </a>
                <div class="dropdown-menu  position-absolute" aria-labelledby="app-dropdown">
                    <a class="dropdown-item d-flex" href="/dash-support">
                        <i class="flaticon-computer-6 mr-3"></i>
                        <span>
                            Tableau de bord
                        </span>
                    </a>
                    <a class="dropdown-item d-flex" href="/dash-support">
                        <i class="flaticon-menu-list"></i>
                        <span>Demandes</span>
                    </a>
                    <a class="dropdown-item d-flex" routerLink="support-survey">
                        <i class="flaticon-multi-star-fill"></i>
                        <span> Enquêtes</span>
                    </a>
                </div>
            </li>
        </ul>
        <ul class="navbar-nav flex-row mr-auto" *ngIf="role=='asst'">
            <li class="nav-item dropdown app-dropdown">
                <a href="javascript:void(0);" class="nav-link dropdown-toggle icon_menu_mobile" id="app-dropdown" 
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="flaticon-menu-line-2"></span>
                </a>
                <div class="dropdown-menu  position-absolute" aria-labelledby="app-dropdown">
                      <a class="dropdown-item d-flex" href="dash">
                          <i class="flaticon-computer-6 mr-3"></i><span>Tableau de bord</span>
                      </a>
                      <a class="dropdown-item d-flex" href="visites" routerLink="/visites">
                          <i class="mr-3 flaticon-car-1"></i><span>Visites</span>
                      </a>
                      <a class="dropdown-item d-flex" href="actions" *ngIf="connectedUser?.roles?.includes('ACTION_CONSULTATION_LISTE_ACTIONS_FAITES_EQUIPE')">
                        <i class="mr-3 flaticon-menu-list"></i><span>Actions</span>
                        </a>
                      <a class="dropdown-item d-flex" href="customers/show;cs=all" routerLink="customers/show;cs=all">
                          <i class="mr-3 flaticon-building-1"></i><span>Clients</span>
                      </a>
                      <a class="dropdown-item d-flex" href="contacts">
                        <i class="mr-3 fa fa-address-book-o"></i><span>Contacts</span>
                      </a>
                      <a class="dropdown-item d-flex" routerLink="absence">
                        <i class="flaticon-calendar-1"></i><span>Absences</span>
                      </a>
                      <a data-toggle="collapse" aria-expanded="false" class="dropdown-toggle dropdown-item d-flex" href="staticticss" *ngIf="comp =='WAM'">
                        <i class="mr-3 flaticon-stats"></i><span>Statistiques</span>
                        <!-- <div>
                            <i class="flaticon-down-arrow flaticon-down-arrow-menu"></i>
                        </div> -->
                    </a>
                    <div class="collapse submenu list-unstyled" id="staticticss" style="display: block;">                            
                        <div class="row">
                            <div class="col-lg-4 div-submenu-element-mobile">
                                <ul class="list-unstyled submenu-element-mobile">
                                    <li><span style="font-size: xx-large;
                                        color: #70e3bc;">L</span>
                                        <a href="/statistics_customers" routerLink="statistics_customers" data-toggle="collapse" aria-expanded="true" class="dropdown-toggle p-0"> 
                                            <i class="flaticon-building-1"></i> Clients 
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-4 div-submenu-element-mobile">
                                <ul class="list-unstyled submenu-element-mobile">
                                    <li><span style="font-size: xx-large;
                                        color: #70e3bc;">L</span>
                                        <a href="/statistics" routerLink="statistics"  data-toggle="collapse" aria-expanded="true" class="dropdown-togglep-0"> 
                                            <i class="flaticon-user-group-1"></i> Commerciaux 
                                        </a>
                                        
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-4 div-submenu-element-mobile">
                                <ul class="list-unstyled submenu-element-mobile">
                                    <li><span style="font-size: xx-large;
                                        color: #70e3bc;">L</span>
                                        <a data-toggle="collapse" aria-expanded="true" class="dropdown-togglep-0" href="/cover" routerLink="cover">
                                            <i class="flaticon-primary"></i> Couverture
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <ul class="navbar-nav flex-row mr-auto" *ngIf="role !='asst' && role !='cmrc' && role !='adm-MF' && role !='adm' && role !='support'">
            <li class="nav-item dropdown app-dropdown">
                <a href="javascript:void(0);" class="nav-link dropdown-toggle icon_menu_mobile" id="app-dropdown" 
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="flaticon-menu-line-2"></span>
                </a>
                <div class="dropdown-menu  position-absolute" aria-labelledby="app-dropdown">
                    <a class="dropdown-item d-flex" href="dashboard" *ngIf="hasRole('dashboard')">
                        <i class="flaticon-computer-6 mr-3"></i><span>Tableau de bord</span>
                    </a>
                    <a class="dropdown-item d-flex" href="visites" routerLink="/visites" *ngIf="hasRole('visites')">
                        <i class="mr-3 flaticon-car-1"></i><span>Visites</span>
                    </a>
                    <a class="dropdown-item d-flex" href="actions" routerLink="/actions" *ngIf="hasRole('actions')">
                        <i class="mr-3 flaticon-menu-list"></i><span>Actions</span>
                    </a>
                    <a class="dropdown-item d-flex" href="customers/show;cs=all" routerLink="customers/show;cs=all" *ngIf="hasRole('clients')">
                        <i class="mr-3 flaticon-building-1"></i><span>Clients</span>
                    </a>
                    <a class="dropdown-item d-flex" href="contacts" *ngIf="hasRole('team')">
                        <i class="mr-3 fa fa-address-book-o"></i><span>Contacts</span>
                    </a>
                    <a data-toggle="collapse" aria-expanded="false" class="dropdown-toggle dropdown-item d-flex" href="staticticss" *ngIf="hasRole('statistics')">
                        <i class="mr-3 flaticon-stats"></i><span>Statistiques</span>
                    </a>
                    <div class="collapse submenu list-unstyled" id="staticticss" style="display: block;">
                        <div class="row" *ngIf="hasRole('statistics')">
                            <div class="col-lg-4 div-submenu-element-mobile">
                                <ul class="list-unstyled submenu-element-mobile">
                                    <li>
                                        <span style="font-size: xx-large; color: #70e3bc;">L</span>
                                        <a href="/statistics_customers" routerLink="statistics_customers" data-toggle="collapse" aria-expanded="true" class="dropdown-toggle p-0">
                                            <i class="flaticon-building-1"></i> Clients
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-4 div-submenu-element-mobile">
                                <ul class="list-unstyled submenu-element-mobile">
                                    <li>
                                        <span style="font-size: xx-large; color: #70e3bc;">L</span>
                                        <a href="statistics" routerLink="statistics" data-toggle="collapse" aria-expanded="true" class="dropdown-togglep-0">
                                            <i class="flaticon-user-group-1"></i> Commerciaux
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-4 div-submenu-element-mobile">
                                <ul class="list-unstyled submenu-element-mobile">
                                    <li>
                                        <span style="font-size: xx-large; color: #70e3bc;">L</span>
                                        <a data-toggle="collapse" aria-expanded="true" class="dropdown-togglep-0" href="cover" routerLink="cover">
                                            <i class="flaticon-primary"></i> Couverture
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <div class="navbar-brand text-center" *ngIf="!mobile">
            <h4 class="mb-0" style="font-weight: 600;color: white">Gestion des visites clients</h4>
        </div>

        <ul class="navbar-nav flex-row ml-lg-auto">
            <li class="nav-item dropdown user-profile-dropdown mr-3 d-lg-inline-block d-none">
                <a href="profil" class="nav-link dropdown-toggle user"  aria-expanded="false">
                    <div class="media">
                        <!-- <div class="avatar-box mr-2">
                            <div class="avatar-content">

                                <img [src]="logoCompany" *ngIf="logoCompany!=null && logoCompany != undefined && !loadingImages" alt="avatar">
                                <img src="../assets/img/logo_toIco.png" *ngIf="(logoCompany==null || logoCompany == undefined) && !loadingImages" alt="avatar">
                                <img src="../assets/img/suivitim_img/loading_imgs.gif" style="width: 20px !important;" *ngIf="loadingImages" alt="avatar">
                            </div>
                        </div> -->
                        <!-- <div class="img-wrapper"> //ANIMATION BORDER -->
                            <img [src]="imagesource" class="img-fluid mr-2" *ngIf="imagesource!=null && imagesource != undefined && !loadingImages" alt="admin-profile" 
                                [ngClass]="{'border-basic': myPack==='Basique' && role=='adm','border-custom':  myPack==='Sur mesure' && role=='adm','border-advanced':  myPack==='Advanced' && role=='adm','border-premium':  myPack==='Premium' && role=='adm'}">
                            <img src="../assets/img/suivitim_img/unknown_user.jpg" class="img-fluid mr-2" *ngIf="(imagesource==null || imagesource == undefined) && !loadingImages" alt="admin-profile"
                                [ngClass]="{'border-basic': myPack==='Basique' && role=='adm','border-custom':  myPack==='Sur mesure' && role=='adm','border-advanced':  myPack==='Advanced' && role=='adm','border-premium':  myPack==='Premium' && role=='adm'}">
                        <!-- </div> -->
                        <img src="../assets/img/suivitim_img/loading_imgs.gif" style="width: 20px !important;height: auto !important;margin: 15px;" *ngIf="loadingImages" alt="avatar">
                        <div class="media-body align-self-center">
                            <h6 class="mb-1">{{fullnameconnected}}</h6>
                            <p class="mb-0">{{roleconnected}}</p>
                            <p class="mb-0" style="font-size: 12px;color: #a8f1ff;" 
                                *ngIf="connectedCompany!=null && connectedCompany != undefined && role!='adm-MF'">
                                <b>{{connectedCompany}}</b></p>
                        </div>
                    </div>
                </a>
            </li>
            <li class="nav-item dropdown message-dropdown  mr-2" *ngIf="role!='adm-MF' && role !='support'">
                <a href="javascript:void(0);" class="nav-link dropdown-toggle" id="message-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="icon flaticon-chat-bubble"></span>
                    <span class="badge badge-primary p-2 indicator_notification" 
                        *ngIf="notifCommentsToReply.length>0" style="width: 25px;
                        height: 25px;padding: 2px!important;" [ngClass]="{'exist_urgent_msg': existImportantComment,' ': !existImportantComment}">
                        {{notifCommentsToReply.length}}</span>
                </a>
                <div class="dropdown-menu  position-absolute p-0" [ngClass]="{'admin':role=='adm'}" aria-labelledby="message-dropdown">
                    <div class="dropdown-item dropdown-header d-flex justify-content-between">
                        <p class="mb-0 align-self-center"><a  class="nav-link dropdown-toggle" href="/messages/fromall">Affiché tous les messages</a></p>
                        <div class="">
                            <img src="assets/img/suivitim_img/click_here.gif" alt="" style="width:25px;float: right;right: 0px;
                                    position: absolute;opacity: 0.5;" class="icon_click_here">
                        </div>
                    </div>
                    <div class="dropdown-item dropdown-header d-flex justify-content-between">
                        <p class="mb-0 align-self-center" *ngIf="notifCommentsToReply.length!=0">
                            Vous avez de nouveaux messages</p>
                        <p class="mb-0 align-self-center" *ngIf="notifCommentsToReply.length==0">
                            Aucun message</p>
                        <div class="">
                            <i class="flaticon-chat-bubble"></i>
                        </div>
                    </div>
                    <div class="dropdown-divider"></div>
                    <div class="message-scroll mCustomScrollbar">
                        <p style="font-size: x-small;
                        text-align: center;
                        margin-bottom: 25%;
                        margin-top: 25%;" *ngIf="notifCommentsToReply.length==0">Aucun message à répondre n'est reçu</p>
                        <div class="dropdown-item" *ngFor="let comment of notifCommentsToReply">
                            <div class="">
                                <div class="media mt-2">
                                    <div class="usr-img online mr-3">
                                        <img class="usr-img rounded-circle" [src]="comment?.commercial_avatar ? 'data:image/jpeg;base64,' + comment?.commercial_avatar : '../../assets/img/unknown_user.jpg'" alt="Profile" >
                                    </div>
                                    <div class="media-body">
                                        <div class="d-flex">
                                            <p class="meta-user-name mr-3 mb-2">{{comment?.commercial_fullname}}
                                                <br *ngIf="mobile"><span *ngIf="mobile" style="font-size: smaller;color:gray;"> {{comment?.lastCommentAt}}</span>
                                            </p>
                                            <p class="meta-time align-self-center mb-1" *ngIf="!mobile">
                                                {{comment?.lastCommentAt}}</p>
                                                
                                        </div>
                                        <p class="text-primary" style="font-size: smaller;white-space: normal;" *ngIf="comment?.visit">Visite de : {{comment?.visit_customer}}</p>
                                        <p class="text-primary" style="font-size: smaller;white-space: normal;" *ngIf="comment?.customer">Client : {{comment?.customer}}</p>
                                        <p class="message-text mb-0 mb-2" style="color:#0e23a3 !important;">
                                            <span *ngIf="comment?.containsPj">
                                                <span *ngIf="comment.fileType.includes('image')"><i class="flaticon-picture"></i> image</span>
                                                <span *ngIf="comment.fileType == 'application/pdf'"><i class="flaticon-file"></i> pdf</span>
                                                <span *ngIf="comment.fileType == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'"><i class="flaticon-file"></i> document</span>
                                                <br>
                                            </span>    {{(comment?.visit_last_comment?.length>30)? (comment?.visit_last_comment | slice:0:30)+'...':(comment?.visit_last_comment)}} </p>
                                        <p>
                                            <span *ngIf="comment.is_important">
                                                <img src="../assets/img/suivitim_img/hey_reply.gif"style="border: unset !important;width:25px !important;height:25px !important;"> 
                                                <span style="font-size: x-small;color:rgb(204, 62, 62);">
                                                    " J'attends votre réponse ! "
                                                </span>
                                            </span>
                                        </p>
                                        <!-- <a [attr.href]="comment?.visit ? 'visite/detail/fromcomments;cr='+comment?.visit : role=='cmrc' ? 'my-customers/show;cs='+comment?.customer:'customers/show;cs='+comment?.customer"  -->
                                            <!-- <a [attr.href]="comment?.visit ? 'visite/detail/fromcomments;cr='+comment?.visit :  'customer/fromnotif;cs=' + comment?.customer" class="see-more" (click)="MarkAsRead(comment.visit, comment.customer)">Plus de détails</a> -->
                                            <a [attr.href]="'/messages/fromdetail;mb='+comment?.commercial_uuid" class="see-more" (click)="MarkAsRead(comment.visit, comment.customer)">Plus de détails</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="cs-toggle tooltip-section" [ngClass]="{'d-flex align-items-center': mobile}" *ngIf="role !='support'">
                <a routerLink="support" aria-expanded="false" class="nav-link toggle-control-sidebar suffle">
                    <img src="../assets/img/support-img.png" width="53" *ngIf="!mobile">
                    <img src="../assets/img/support-img-mobile.png" width="27" *ngIf="mobile">
                </a>
            </li>
            <li class="nav-item dropdown notification-dropdown ml-2 mr-2" *ngIf="role=='adm'">
                <a href="referential" class="nav-link dropdown-toggle" id="referential-dropdown" title="Réferentiel/Configuration" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="icon flaticon-dots"></span>
                </a>
                <div class="dropdown-menu  position-absolute p-0" aria-labelledby="message-dropdown" style="min-width: 183px !important;">
                    <div class="message-scroll" >
                        <div class="dropdown-item p-1 mb-0">
                            <li class="nav-item ml-3 mr-lg-4" *ngIf="role=='adm'">
                                <a href="/users/show;cs=all" class="nav-link sous-menu" id="users-dropdown" title="users" >
                                    <i class="flaticon-user-group"></i> Utilisateurs
                                </a>
                            </li>
                        </div>
                        <div class="dropdown-item p-1 mb-0">
                            <li class="nav-item dropdown cs-toggle ml-3 mr-lg-4 tooltip-section">
                                <a href="audit_traces" class="nav-link sous-menu" id="notification-dropdown" title="Journal d'audit">
                                    <span class="mif-history" style="width: fit-content;"></span> Journal d'audit
                                </a>
                            </li>
                        </div>
                        <div class="dropdown-item p-1 mb-0">
                            <li class="nav-item ml-3 mr-lg-4" *ngIf="role=='adm'">
                                <a href="referential" class="nav-link sous-menu" id="referential-dropdown" title="Referential" >
                                    <span class="fa fa-database"></span> Référentiel
                                </a>
                            </li>
                        </div>
                        <div class="dropdown-item p-1 mb-0">
                            <li class="nav-item dropdown cs-toggle ml-3 mr-lg-4 tooltip-section">
                                <a href="configuration" class="nav-link sous-menu" id="notification-dropdown" title="Configuration">
                                    <span class="flaticon-setting-1" style="width: fit-content;"></span> Configuration
                                </a>
                            </li>
                        </div>
                    </div>
                </div>
            </li>
            <li class="nav-item dropdown cs-toggle ml-2 mr-lg-4 tooltip-section"> 
                <a (click)="disconnect()" href="#" title="Déconnexion" class="nav-link toggle-control-sidebar suffle">
                    <span class="icon flaticon-log-3"></span>
                </a>
            </li>
        </ul>
    </header>
<!--  END NAVBAR  -->
<!--  BEGIN TOPBAR  -->
    <div class="topbar-nav header navbar fixed-top" role="banner" *ngIf="logged !=undefined && !landing_page" [style.color]="comp =='WAM' ? '#042340 !important': '#3232b7'">
        <div id="dismiss" class="d-lg-none text-right"><i class="flaticon-cancel-12 mr-3"></i></div>
        <nav id="topbar" *ngIf="role=='adm'">
            <ul class="list-unstyled menu-categories d-lg-flex justify-content-lg-around mb-0" id="topAccordion">
                <li class="menu">
                    <a href="dashboard" aria-expanded="false" class="active" >
                        <div class="">
                            <i class="flaticon-computer-6"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Tableau de bord</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a href="visites" aria-expanded="false" >
                        <div class="">
                            <i class="flaticon-car-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Visites</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a href="actions" aria-expanded="false" >
                        <div class="">
                            <i class="flaticon-menu-list"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Actions</span>
                        </div>
                    </a>
                </li>
                <!-- <li class="menu">
                    <a href="cover" aria-expanded="false" >
                        <div class="">
                            <i class="flaticon-primary"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Couverture</span>
                        </div>
                    </a>
                </li> -->
                <li class="menu">
                    <a href="customers/show;cs=all" aria-expanded="false" routerLink="customers/show;cs=all">
                        <div class="">
                            <i class="flaticon-building-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Clients</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a href="contacts" aria-expanded="false" routerLink="contacts">
                        <div class="">
                            <i class="fa fa-address-book-o"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Contacts</span>
                        </div>
                    </a>
                </li>
                <li class="menu" >
                    <a routerLink="absence" aria-expanded="false">
                        <div class="">
                            <i class="flaticon-calendar-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Absences</span>
                        </div>
                    </a>
                </li>
                <li *ngIf="hasRole('satisfaction')" class="menu" >
                    <a routerLink="surveys-list" aria-expanded="false">
                        <div class="">
                            <i class="flaticon-multi-star-fill"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Enquêtes</span>
                        </div>
                    </a>
                </li>
                <li class="menu" id="statisticsmenu" >
                    <a href="javascript:void(0);" aria-expanded="false" data-toggle="collapse" 
                        aria-expanded="false" class="dropdown-toggle" (click)="showMenu=!showMenu">
                        <div class="">
                            <i class="flaticon-stats"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Statistiques</span>
                                <i class="flaticon-down-arrow"></i>
                        </div>
                    </a>
                    <ul class="collapse submenu list-unstyled topMenu" id="dashboard" data-parent="#topAccordion" style="top: 42px;" 
                        [ngStyle]="{'display': showMenu ? 'block' : (!showMenu ? 'none' : null) }">
                        <li class="p-0" >
                            <ul class="collapse list-unstyled sub-submenu m-0" id="dashboards" [ngClass]="showMenu ? 'show' : 'hide'">
                                <li class="p-0 nav-item">
                                    <a href="/statistics_customers" routerLink="statistics_customers" class="p-0 pl-2"
                                        (click)="showMenu=!showMenu"> <i class="flaticon-building-1"></i> Clients</a>
                                </li>
                                <li class="p-0 nav-item">
                                    <a href="/statistics" routerLink="statistics" class="p-0 pl-2" (click)="showMenu=!showMenu"> 
                                        <i class="flaticon-user-group-1"></i> Commerciaux</a>
                                </li>
                                <li class="p-0 nav-item">
                                    <a href="/cover" routerLink="cover" class="p-0 pl-2" (click)="showMenu=!showMenu">
                                        <i class="flaticon-primary"></i> Couverture
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
        <nav id="topbar" *ngIf="role=='cmrc'">
            <ul class="list-unstyled menu-categories d-lg-flex justify-content-lg-around mb-0" id="topAccordion">
                <li class="menu">
                    <a href="mydash" routerLink="/mydash" aria-expanded="false" class="active">
                        <div class="">
                            <i class="flaticon-computer-6"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Tableau de bord</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a href="deplacement" aria-expanded="false" >
                        <div class="">
                            <i class="flaticon-car-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Déplacements</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a href="actions" aria-expanded="false" >
                        <div class="">
                            <i class="flaticon-menu-list"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Actions</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a href="my-customers/show;cs=all" aria-expanded="false" routerLink="my-customers/show;cs=all">
                        <div class="">
                            <i class="flaticon-building-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Clients</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a href="contacts" aria-expanded="false" routerLink="contacts">
                        <div class="">
                            <i class="fa fa-address-book-o"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Contacts</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a routerLink="absence" aria-expanded="false">
                        <div class="">
                            <i class="flaticon-calendar-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Absences</span>
                        </div>
                    </a>
                </li>
            </ul>
        </nav>
        <nav id="topbar" *ngIf="role=='support'">
            <ul class="list-unstyled menu-categories d-lg-flex justify-content-lg-around mb-0" id="topAccordion">
                <li class="menu">
                    <a href="/dash-support" aria-expanded="false" class="active">
                        <div class="">
                            <i class="flaticon-computer-6"></i>
                            <span>Tableau de bord</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a routerLink="tickets"  aria-expanded="false" >
                        <div class="">
                            <i class="flaticon-menu-list"></i>
                            <span>Demandes</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a routerLink="support-survey"  aria-expanded="false" >
                        <div class="">
                            <i class="flaticon-multi-star-fill"></i>
                            <span> Enquêtes</span>
                        </div>
                    </a>
                </li>
            </ul>
        </nav>
        <nav id="topbar" *ngIf="role=='asst'">
            <ul class="list-unstyled menu-categories d-lg-flex justify-content-lg-around mb-0" id="topAccordion">
                <li class="menu">
                    <a href="dash" aria-expanded="false" class="active" >
                        <div class="">
                            <i class="flaticon-computer-6"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Tableau de bord</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a href="visites" aria-expanded="false" >
                        <div class="">
                            <i class="flaticon-car-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Visites</span>
                        </div>
                    </a>
                </li>
                <li class="menu" *ngIf="connectedUser?.roles?.includes('ACTION_CONSULTATION_LISTE_ACTIONS_FAITES_EQUIPE')">
                    <a href="actions" aria-expanded="false" >
                        <div class="">
                            <i class="flaticon-menu-list"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Actions</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a href="customers/show;cs=all" aria-expanded="false" routerLink="customers/show;cs=all">
                        <div class="">
                            <i class="flaticon-building-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Clients</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a href="contacts" aria-expanded="false" routerLink="contacts">
                        <div class="">
                            <i class="fa fa-address-book-o"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Contacts</span>
                        </div>
                    </a>
                </li>
                <li class="menu">
                    <a routerLink="absence" aria-expanded="false">
                        <div class="">
                            <i class="flaticon-calendar-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Absences</span>
                        </div>
                    </a>
                </li>
                <li class="menu" id="statisticsmenu" *ngIf="comp=='WAM'">
                    <a href="statistics" aria-expanded="false" href="#dashboard" data-toggle="collapse" 
                        aria-expanded="false" class="dropdown-toggle" (click)="showMenu=!showMenu">
                        <div class="">
                            <i class="flaticon-stats"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Statistiques</span>
                                <i class="flaticon-down-arrow"></i>
                        </div>
                    </a>
                    <ul class="collapse submenu list-unstyled topMenu" id="dashboard" data-parent="#topAccordion" style="top: 42px;" 
                        [ngStyle]="{'display': showMenu ? 'block' : (!showMenu ? 'none' : null) }">
                        <li class="p-0" >
                            <ul class="collapse list-unstyled sub-submenu m-0" [ngClass]="showMenu ? 'show' : 'hide'">
                                <li class="p-0 nav-item">
                                    <a href="/statistics_customers" routerLink="statistics_customers" class="p-0 pl-2"
                                        (click)="showMenu=!showMenu"> <i class="flaticon-building-1"></i> Clients</a>
                                </li>
                                <li class="p-0 nav-item">
                                    <a href="/statistics" routerLink="statistics" class="p-0 pl-2" (click)="showMenu=!showMenu"> 
                                        <i class="flaticon-user-group-1"></i> Commerciaux</a>
                                </li>
                                <li class="p-0 nav-item">
                                    <a href="/cover" routerLink="cover" class="p-0 pl-2" (click)="showMenu=!showMenu">
                                        <i class="flaticon-primary"></i> Couverture
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
        <nav id="topbar" *ngIf="role=='adm-MF'">
            <ul class="list-unstyled menu-categories d-lg-flex justify-content-lg-around mb-0" id="topAccordion">
                <li class="menu">
                    <a routerLink="/administration" aria-expanded="false" class="active" >
                        <div class="">
                            <i class="flaticon-user-group-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Comptes Entreprises</span>
                        </div>
                    </a>
                </li>
            </ul>
        </nav>
        <nav id="topbar" *ngIf="role !='asst' && role !='cmrc' && role !='adm-MF' && role !='adm'">
            <ul class="list-unstyled menu-categories d-lg-flex justify-content-lg-around mb-0" id="topAccordion">
                <li class="menu"  *ngIf="hasRole('dashboard')">
                    <a href="dashboard" aria-expanded="false" class="active">
                        <div class="">
                            <i class="flaticon-computer-6"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Tableau de bord</span>
                        </div>
                    </a>
                </li>
                <li class="menu" *ngIf="hasRole('visites')">
                    <a href="visites" aria-expanded="false" >
                        <div class="">
                            <i class="flaticon-car-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Visites</span>
                        </div>
                    </a>
                </li>
                <li class="menu" *ngIf="hasRole('actions')">
                    <a href="actions" aria-expanded="false"  >
                        <div class="">
                            <i class="flaticon-menu-list"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Actions</span>
                        </div>
                    </a>
                </li>
                <li class="menu" *ngIf="hasRole('clients')">
                    <a href="customers/show;cs=all" aria-expanded="false" routerLink="customers/show;cs=all" >
                        <div class="">
                            <i class="flaticon-building-1"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Clients</span>
                        </div>
                    </a>
                </li>
                <li class="menu" id="statisticsmenu" *ngIf="hasRole('statistics')">
                    <a href="statistics" aria-expanded="false" href="#dashboard" data-toggle="collapse" 
                        aria-expanded="false" class="dropdown-toggle" (click)="showMenu=!showMenu" >
                        <div class="">
                            <i class="flaticon-stats"></i>
                            <span [style.color]="comp =='WAM' ? '#fff200 !important': '#d3d3d3'">Statistiques</span>
                                <i class="flaticon-down-arrow"></i>
                        </div>
                    </a>
                    <ul class="collapse submenu list-unstyled topMenu" id="dashboard" data-parent="#topAccordion" style="top: 42px;" 
                        [ngStyle]="{'display': showMenu ? 'block' : (!showMenu ? 'none' : null) }">
                        <li class="p-0" >
                            <ul class="collapse list-unstyled sub-submenu m-0" id="dashboards" [ngClass]="showMenu ? 'show' : 'hide'">
                                <li class="p-0 nav-item">
                                    <a href="/statistics_customers" routerLink="statistics_customers" class="p-0 pl-2"
                                        (click)="showMenu=!showMenu"> <i class="flaticon-building-1"></i> Clients</a>
                                </li>
                                <li class="p-0 nav-item">
                                    <a href="/statistics" routerLink="statistics" class="p-0 pl-2" (click)="showMenu=!showMenu"> 
                                        <i class="flaticon-user-group-1"></i> Commerciaux</a>
                                </li>
                                <li class="p-0 nav-item">
                                    <a href="/cover" routerLink="cover" class="p-0 pl-2" (click)="showMenu=!showMenu">
                                        <i class="flaticon-primary"></i> Couverture
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
    </div>
</div>
<!--  END TOPBAR  -->
    <router-outlet></router-outlet>
    <div   *ngIf="!hideHeader">
        <div class="col-xl-12 col-md-12 col-sm-12 col-12" *ngIf="!signinpage && !landing_page" style="position: absolute;
            z-index: 20;">
            <ul class="list-inline mb-3 d-flex justify-content-sm-end justify-content-center mr-sm-3 ml-sm-0 mx-3">
                <li class="list-inline-item align-self-center">
                    <div class="scrollTop"><i class="flaticon-up-arrow-fill-1"></i></div>
                </li>
            </ul>
        </div>
        <!--  BEGIN FOOTER  -->
        <footer class="footer-section theme-footer" *ngIf="logged ==undefined || logged == null">
            <div class="footer-section-1  sidebar-theme">
            </div>
            <div class="footer-section-2 container-fluid">
                <div class="row">
                    <!-- <div id="toggle-grid" class="col-xl-7 col-md-6 col-sm-6 col-12 text-sm-left text-center">
                        <ul class="list-inline links ml-sm-5">
                            <li class="list-inline-item mr-3">
                                <a href="javascript:void(0);">Accueil</a>
                            </li>
                            <li class="list-inline-item mr-3">
                                <a href="javascript:void(0);">A propos</a>
                            </li>
                            <li class="list-inline-item mr-3">
                                <a href="javascript:void(0);">Acheter</a>
                            </li>
                        </ul>
                    </div> -->
                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                        <ul class="list-inline mb-0 mr-sm-3 ml-sm-0 mx-3 text-center">
                            <li class="list-inline-item  mr-3">
                                <p class="bottom-footer">&#xA9; {{currentDate | date : 'yyyy'}} <a target="_blank" href="https://itimdex.com">itimdex</a></p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
        <!--  END FOOTER  -->
    </div>